<template>
    <a-modal title="资源上传中" :centered="true" width="800px"
             :visible="$store.getters['file/getVisible']"
             @cancel="cancel"
             :footer="null">
        <div @click="popoverVisible = false">
            <a-table :columns="columns"
                     rowKey="uploadId"
                     :pagination="table.tablePagination"
                     :loading="table.tableLoading"
                     :dataSource="$store.getters['file/getUploadFileList']">
                <div slot="status" slot-scope="text">
                    <span v-if="text.status === 0">等待上传</span>
                    <span v-else-if="text.status === -1" style="color: red;">上传失败</span>
                    <a-progress v-else :percent="text.progress"/>
                </div>
                <div slot="action" class="action" slot-scope="text, prop, index">
                    <div v-if="text.progress < 100" class="table-btn" @click.stop>
                        <div v-show="popoverVisible === index" class="ant-popover ant-popover-placement-top">
                            <div class="ant-popover-content">
                                <div class="ant-popover-arrow"></div>
                                <div role="tooltip" class="ant-popover-inner">
                                    <div class="ant-popover-inner-content">
                                        <div class="ant-popover-message" style="white-space: nowrap;">
                                            <a-icon style="color: #faad14;" type="info-circle"/>
                                            <div class="ant-popover-message-title">确定取消上传？</div>
                                        </div>
                                        <div class="ant-popover-buttons" style="display: flex">
                                            <button @click="popoverVisible = false" type="button"
                                                    class="ant-btn ant-btn-sm">取 消
                                            </button>
                                            <button @click="confirm(text)" type="button"
                                                    class="ant-btn ant-btn-primary ant-btn-sm">确 定
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a @click="popoverVisible = index" href="javascript:;" class="red">取消上传</a>
                    </div>
                    <span v-else>取消上传</span>
                </div>
            </a-table>
            <div style="text-align: center;margin-top: 20px;">
                <a-button @click="cancel" type="primary" style="width: 200px;">后台上传</a-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils";
import Popconfirm from 'ant-design-vue/lib/popconfirm/index'

export default {
    name: "uploadTable",
    components: {Popconfirm},
    data() {
        return {
            columns: [
                {
                    title: '资源名称',
                    dataIndex: "name",
                    ellipsis: true,
                    width: 300
                },
                {
                    title: '大小',
                    dataIndex: "size"
                },
                {
                    title: '状态',
                    scopedSlots: {customRender: 'status'},
                },
                {
                    title: '操作',
                    scopedSlots: {customRender: 'action'},
                },
            ],
            table: tableRelevant.call(this),
            popoverVisible: false,
        }
    },
    methods: {
        cancel() {
            this.popoverVisible = false;
            this.$store.commit('file/setVisible', false)
        },
        confirm(val) {
            try {
                if (val.type === "video") {
                    val.uploader.stopUpload();
                    const list = val.uploader.listFiles();
                    for (let i = 0; i < list.length; i++) {
                        val.uploader.cancelFile(i);
                        val.uploader.deleteFile(i);
                    }
                    val.uploader.cleanList();
                } else {
                    this.$store.getters["file/getOSS"]().abortMultipartUpload(val.uploadName, val.uploadId);
                }
            } catch (e) {
                console.error(e);
            }
            this.popoverVisible = false;
            this.$store.commit("file/setUploadFileList", this.$store.getters["file/getUploadFileList"].filter(f => {
                if (f.uploadId && f.status !== 0) {
                    return f.uploadId !== val.uploadId
                }
                return true;
            }))
            this.$store.dispatch("file/startUpload");
        }
    }
}
</script>

<style scoped lang="less">
.table-btn {
    position: relative;
    display: inline-block;

    .ant-popover {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, -100%);
    }
}
</style>